import { useState } from "react";
import { Input } from "@/components/ui/input";
import { SearchResults } from "./SearchResults";
import { SearchResult } from "@/types/client-search";

interface ClientSearchProps {
  onClientSelect: (client: SearchResult) => void;
}

export const ClientSearch = ({ onClientSelect }: ClientSearchProps) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState<SearchResult[]>([]);

  const handleSearch = async (value: string) => {
    setSearchTerm(value);
    // Basic client search functionality
    setSearchResults([]);
  };

  return (
    <div className="relative w-full">
      <Input
        type="text"
        placeholder="Search clients..."
        value={searchTerm}
        onChange={(e) => handleSearch(e.target.value)}
        className="w-full"
      />
      {searchTerm && searchResults.length > 0 && (
        <SearchResults
          results={searchResults}
          onSelect={onClientSelect}
        />
      )}
    </div>
  );
};
